<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <company-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CompanyShowData from "./CompanyShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CompanyShow",
        components: {CrudShow, CompanyShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'admin.company.showing',
            }
        },
    }
</script>
